export default {
  storeFeatureFlags(state, val) {
    state.enabledFeatures = val
  },
}
